import { Component, Input, OnInit, OnDestroy, SimpleChanges, OnChanges,
         ViewChild, ElementRef, EventEmitter, Output } from '@angular/core';
import { WjInputDate } from '@grapecity/wijmo.angular2.input';

import { KYMW1600Model } from '../kymw1600.model';
import { OrderCodeTextInputComponent } from '../../../../commons/kymw02/text-input/order-code-text-input/order-code-text-input.component';
import { CodeComboBoxComponent } from '../../../../commons/kymw02/combo-box/code-combo-box/code-combo-box.component';
import { StudioMasterComboBoxComponent } from '../../../../commons/kymw02/combo-box/studio-master-combo-box/studio-master-combo-box.component';
/**
 * 画面情報詳細ボックス部品を制御するクラス
 *
 * @export
 * @class ImageInfoDetailBoxComponent
 * @implements {OnInit}
 * @implements {OnChanges}
 * @implements {OnDestroy}
 */
@Component({
    selector: 'app-image-info-detail-box',
    templateUrl: 'image-info-detail-box.component.html',
    styleUrls: ['image-info-detail-box.component.scss']
})

export class ImageInfoDetailBoxComponent implements OnInit {

  // レイアウト系の変数
  @Input() left: number = <number>0;
  @Input() top: number = <number>0;
  @Input() width: number = <number>100;
  @Input() height: number = <number>20;
  @Input() disabled: boolean; // trueの時disableにする
  @Input() parentModel: KYMW1600Model;

  @ViewChild('txi_StartOrderCode', { static: true }) txi_StartOrderCode: OrderCodeTextInputComponent; // 共通部品
  @ViewChild('txi_EndOrderCode1', { static: true }) txi_EndOrderCode1: OrderCodeTextInputComponent; // 共通部品
  @ViewChild('cmb_EndOrderCode2', { static: true }) cmb_EndOrderCode2: ElementRef; // 共通部品
  @ViewChild('cmb_ProcessInstruct', { static: true }) cmb_ProcessInstruct: CodeComboBoxComponent; // 共通部品
  @ViewChild('txi_Remarks', { static: true }) txi_Remarks: ElementRef;
  @ViewChild('ckb_CookingExPublish', { static: true }) ckb_CookingExPublish: ElementRef;
  @ViewChild('txi_Priority', { static: true }) txi_Priority: ElementRef;
  @ViewChild('cmb_CookingDiv', { static: true }) cmb_CookingDiv: CodeComboBoxComponent; // 共通部品
  @ViewChild('txi_CookingName', { static: true }) txi_CookingName: ElementRef;
  @ViewChild('txi_MaterialName', { static: true }) txi_MaterialName: ElementRef;
  @ViewChild('txi_KeyWord', { static: true }) txi_KeyWord: ElementRef;
  @ViewChild('cmb_EventId', { static: true }) cmb_EventId: CodeComboBoxComponent; // 共通部品
  @ViewChild('cmb_PhotoContentsDiv', { static: true }) cmb_PhotoContentsDiv: CodeComboBoxComponent; // 共通部品
  @ViewChild('txi_PhotoInstructContents', { static: true }) txi_PhotoInstructContents: ElementRef;
  @ViewChild('dfd_PhotoSchedule', { static: true }) dfd_PhotoSchedule: WjInputDate;
  @ViewChild('cmb_PhotoStudioId', { static: true }) cmb_PhotoStudioId: StudioMasterComboBoxComponent; // 共通部品
  @ViewChild('txi_Caption', { static: true }) txi_Caption: ElementRef;

  public endOrderCode2_dataProvider = []; // コンボボックスのリスト

  // 画面表示用変数
  public imageName: string = <string>'';
  public imageFileName: string = <string>'';
  public imageBelongName: string = <string>'';
  public imageKindName: string = <string>'';
  public imageTypeName: string = <string>'';
  public remarks: string = <string>'';
  public cookingExPublish: boolean = <boolean>true; // チェックボックスの値
  public priority: string = <string>'';
  public pcode: string = <string>'';
  public guideGoodsName: string = <string>'';
  public guideStandardName: string = <string>'';
  public cookingName: string = <string>'';
  public materialName: string = <string>'';
  public keyWord: string = <string>'';
  public photoInstructContents: string = <string>'';
  public photoSchedule: string = <string>'';
  public imageInstructDate: string = <string>'';
  public fileRegistDate: string = <string>'';
  public captiontext: string = <string>'';

  public photoStudioId: string = <string>'';
  public photoContentsDiv: string = <string>'';
  public eventId: string = <string>'';
  public cookingDiv: string = <string>'';
  public startOrderCode: string = <string>'';
  public endOrderCode: string = <string>'';
  public endOrderCode2: string = <string>''; // コンボボックスから取得する値
  public processInstruct: string = <string>'';

  /** 活性非活性フラグ 調理指示 */
  public cmbProcessInstructDisabled: boolean = <boolean>true;

  public txiStartOrderCodeDisabled: boolean = <boolean>true;
  public txiEndOrderCode1Disabled: boolean = <boolean>true;
  public cmbEndOrderCode2Disabled: boolean = <boolean>true;
  public txiRemarksDisabled: boolean = <boolean>true;
  public ckbCookingExPublishDisabled: boolean = <boolean>true;
  public txiPriorityDisabled: boolean = <boolean>true;
  public cmbCookingDivDisabled: boolean = <boolean>true;
  public txiCookingNameDisabled: boolean = <boolean>true;
  public txiMaterialNameDisabled: boolean = <boolean>true;
  public txiKeyWordDisabled: boolean = <boolean>true;
  public cmbEventIdDisabled: boolean = <boolean>true;
  public cmbPhotoContentsDivDisabled: boolean = <boolean>true;
  public txiPhotoInstructContentsDisabled: boolean = <boolean>true;
  public cmbPhotoStudioIdDisabled: boolean = <boolean>true;
  public txiCaptionDisabled: boolean = <boolean>true;
  public txitxiEndOrderCode1ReadOnly: boolean = <boolean>false;

  /**
   * 初期化処理
   *
   * @memberof ImageInfoDetailBoxComponent
   */
  ngOnInit(): void {
    // コンボボックスオプション設定
    this.endOrderCode2_dataProvider = [{ label: '　', data: '0' }, { label: '無制限', data: '1' }, { label: '今回のみ', data: '2' }];
  }

  /**
   * コンポーネント活性化処理を行う
   */
  public set componentEnabled(enabled: boolean) {
    const disabled = !enabled;
    this.txiStartOrderCodeDisabled = disabled;
    this.txiEndOrderCode1Disabled = disabled;
    this.cmbEndOrderCode2Disabled = disabled;
    this.txiRemarksDisabled = disabled;
    this.ckbCookingExPublishDisabled = disabled;
    this.txiPriorityDisabled = disabled;
    this.cmbCookingDivDisabled = disabled;
    this.txiCookingNameDisabled = disabled;
    this.txiMaterialNameDisabled = disabled;
    this.txiKeyWordDisabled = disabled;
    this.cmbEventIdDisabled = disabled;
    this.cmbPhotoContentsDivDisabled = disabled;
    this.txiPhotoInstructContentsDisabled = disabled;
    this.dfd_PhotoSchedule.isDisabled = disabled;
    if ( disabled ) {
      this.dfd_PhotoSchedule.hostElement.tabIndex = -1;
    } else {
      this.dfd_PhotoSchedule.hostElement.tabIndex = 0;
    }
    this.cmbPhotoStudioIdDisabled = disabled;
    this.txiCaptionDisabled = disabled;
    this.cmbProcessInstructDisabled = disabled;
  }

  public clear(): void {
    // 各タグの情報初期化
    this.txi_StartOrderCode.setOrderCode('');
    this.txi_EndOrderCode1.setOrderCode('');
    this.endOrderCode2 = '-1';
    this.imageName = '';
    this.imageFileName = '';
    this.imageBelongName = '';
    this.imageKindName = '';
    this.imageTypeName = '';
    this.cmb_ProcessInstruct.setCodeValue('');
    this.remarks = '';
    this.cookingExPublish = false;
    this.priority = '';
    this.pcode = '';
    this.guideGoodsName = '';
    this.guideStandardName = '';
    this.cmb_CookingDiv.setCodeValue('');
    this.cookingName = '';
    this.materialName = '';
    this.keyWord = '';
    this.cmb_EventId.setCodeValue('');
    this.cmb_PhotoContentsDiv.setCodeValue('');
    this.photoInstructContents = '';
    this.photoSchedule = '';
    this.cmb_PhotoStudioId.setStudioId('');
    this.imageInstructDate = '';
    this.fileRegistDate = '';
    this.captiontext = '';
  }

}
